import { FormHorizontal } from '~/components/form/layout';
import { TenantPerformableFormProps } from '~/tenants/common/form';
import ZodFieldSelect from '~/components/zod/ZodFieldSelect';
import { useZodFormFieldSingle } from '~/components/zod/ZodForm';
import { TenantPerformableConfiguration } from '~/tenants/common/performable';
import { BROCHURES_OPTIONS, MLM_BROCHURES_SHIPPING_RUSH, MLM_BROCHURES_SHIPPING_STANDARD } from './MlmBrochuresJob';
import { MlmOrderContext } from '../../model/MlmOrder';
import { MlmBrochureShipping, MlmBrochuresOption } from './MlmBrochuresConfig';

export default function MlmBrochuresForm(_props: TenantPerformableFormProps<MlmOrderContext>) {
  const [_optionName, option] = useZodFormFieldSingle<MlmBrochuresOption>('option');
  const [_quatityName, quatity] = useZodFormFieldSingle<MlmBrochuresOption>('quantity');

  return (
    <TenantPerformableConfiguration>
      <FormHorizontal name="option" label="Size">
        <ZodFieldSelect
          name="option"
          options={Object.entries(BROCHURES_OPTIONS).map(([id, pkg]) => ({
            value: id,
            label: `${pkg.pages} Pages (${pkg.width} x ${pkg.height})`,
          }))}
        />
      </FormHorizontal>

      {option && (
        <FormHorizontal name="quantity" label="Quantity">
          <ZodFieldSelect
            name="quantity"
            options={Object.entries(BROCHURES_OPTIONS[option].revenue).map(([id, _]) => ({
              value: id,
              label: id,
            }))}
          />
        </FormHorizontal>
      )}

      {quatity && (
        <FormHorizontal name="shipping" label="Shipping">
          <ZodFieldSelect
            name="shipping"
            options={[
              // {
              //   label: 'Pickup',
              //   value: MlmBrochureShipping.PICKUP,
              // },
              {
                label: `Standard ( + $${MLM_BROCHURES_SHIPPING_STANDARD})`,
                value: MlmBrochureShipping.STANDARD,
              },
              {
                label: `Rush ( + $${MLM_BROCHURES_SHIPPING_RUSH})`,
                value: MlmBrochureShipping.RUSH,
              },
            ]}
          />
        </FormHorizontal>
      )}
    </TenantPerformableConfiguration>
  );
}
